export default {
	AMAZON: 'amazon',
	FLOCABULARY: 'flocabulary',
	YOUTUBE: 'youtube',
}
